var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { LoadProvider } from './utils/Load/LoadProvider';
import { SortProvider } from './utils/Sort/SortProvider';
import { TableLoader } from '../TableLoader';
import { Container, StyledTable } from './styled';
export const Table = forwardRef((props, ref) => {
    const { children, sortId, sortOrder, onSort, maxHeight, border, hideColRows, dense, layout = 'auto', loading = false, loadingRows = 5, loadingColumns = 5 } = props, rest = __rest(props, ["children", "sortId", "sortOrder", "onSort", "maxHeight", "border", "hideColRows", "dense", "layout", "loading", "loadingRows", "loadingColumns"]);
    return (<SortProvider id={sortId} order={sortOrder} onSort={onSort} hideColRows={hideColRows}>
      <LoadProvider loading={loading} loadingRows={loadingRows} loadingColumns={loadingColumns}>
        <Container ref={ref} $maxHeight={maxHeight} $border={border}>
          <StyledTable $dense={dense} $layout={layout} {...rest}>
            {children}
          </StyledTable>
          <TableLoader />
        </Container>
      </LoadProvider>
    </SortProvider>);
});
